import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['loginButton', 'checkbox']

  toggle() {
    this.loginButtonTarget.disabled = !this.checkboxTarget.checked
  }
}
